import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { useResponsive } from '../../../../hooks';
import {
  NAVBAR_BASE_CONTAINER_HEIGHT,
  NAVBAR_BASE_CONTAINER_HEIGHT_SM,
} from '../../Navbar.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const useNavbarContainerHeight = () => {
  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();
  const { minWidth } = useResponsive();

  // ─── Derived ────────────────────────────────────────────────────────

  const height = minWidth.isSM
    ? NAVBAR_BASE_CONTAINER_HEIGHT_SM
    : NAVBAR_BASE_CONTAINER_HEIGHT + safeAreaBottomInset;

  // ─── Styles ─────────────────────────────────────────────────────────

  const heightStyle = useStyle(() => ({ height }), [height]);
  const offsetStyle = useStyle(() => ({ bottom: height }), [height]);
  const paddingBottomStyle = useStyle(() => ({ paddingBottom: height }), [height]);
  const paddingTopStyle = useStyle(() => ({ paddingTop: height }), [height]);

  // ────────────────────────────────────────────────────────────────────

  return { height, heightStyle, offsetStyle, paddingBottomStyle, paddingTopStyle };
};
